import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    window.gtag("config", "G-86T7KPJYD6", {
      page_path: location.pathname + location.search,
    });

    console.log("Tracked:", location.pathname);
  }, [location]);
};

export default usePageTracking;